import { getBorderCSS } from '../../Components/utils/getCSS';
const Style = ({ attributes, id }) => {

	const { layout, rowGap = "40px", columnGap = "30px", btnBorder, btnSize, btnColor, btnActiveColor, btnBgColor, width, layoutAlign, } = attributes;
	const DeskFontSize = Math.ceil(parseInt(btnSize?.desktop) / 3);
	const TabFontSize = Math.ceil(parseInt(btnSize?.tablet) / 3);
	const MobileFontSize = Math.ceil(parseInt(btnSize?.mobile) / 3);

	return <style dangerouslySetInnerHTML={{
		__html: `

		#${id} .grid {
			grid-gap: ${rowGap} ${columnGap};
			display: ${layout?.desktop === 'grid' ? 'grid' : 'none'};
		}

		#${id} .cardContainer {
			width:${width}%;
			${layoutAlign === "center" ? `margin: 0 auto` : layoutAlign === "left" ? `margin-right:auto` : `margin-left:auto`};
		}
		#${id} .bpswnSwipeLayout {
			display: ${layout?.desktop === 'swipe' ? 'block' : 'none'};
		}

		#${id} .actionBtn .btnList a { 
			${getBorderCSS(btnBorder)};
			width:${btnSize?.desktop}px;
			height:${btnSize?.desktop}px;
			background:${btnBgColor};
			color:${btnColor};
		}

		#${id} .actionBtn .btnList a svg{
			width: ${DeskFontSize}px;
			height: ${DeskFontSize}px;
			fill:${btnColor};
		}

		@media (max-width: 768px) {
			
			#${id} .grid {
				display: ${layout?.tablet === 'grid' ? 'grid' : 'none'};
			}

			#${id} .bpswnSwipeLayout {
				display: ${layout?.tablet === 'swipe' ? 'block' : 'none'};
			}

			#${id} .actionBtn .btnList a { 
				width:${btnSize?.tablet}px;
				height:${btnSize?.tablet}px;
			}

			#${id} .actionBtn .btnList a svg {
				width: ${TabFontSize}px;
				height: ${TabFontSize}px;
			}
		}

		@media (max-width: 576px) {
			
			#${id} .grid {
				display: ${layout?.mobile === 'grid' ? 'grid' : 'none'};
			}

			#${id} .bpswnSwipeLayout {
				display: ${layout?.mobile === 'swipe' ? 'block' : 'none'};
			}
			
			#${id} .actionBtn .btnList a { 
				width:${btnSize?.mobile}px;
				height:${btnSize?.mobile}px;
			}

			#${id} .actionBtn .btnList a svg {
				width: ${MobileFontSize}px;
				height: ${MobileFontSize}px;
			}
		}

		#${id} .actionBtn .btnList .productExit svg{
			 fill:${btnActiveColor};
		}
		
	`}} />;
}
export default Style;